export default ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];
